import type { QueryClient } from "@tanstack/react-query";
import { QueryKeys } from "@/lib/types";
import { createAuthenticatedApi } from "@/lib/utils";
import { PaymentApi } from "@/openapi/generated";
import { ResponseError } from "@/openapi/generated/runtime";

const PAYMENTS_STALE_TIME_MS = 2 * 60 * 1000;

export async function prefetchPaymentsGet(
  userId: number,
  queryClient: QueryClient,
  accessToken: string,
  tenantId: number,
) {
  const service = createAuthenticatedApi(PaymentApi, accessToken);

  await queryClient.prefetchQuery({
    queryKey: [QueryKeys.Payments, userId],
    queryFn: async () => {
      try {
        const payments = await service.apiPaymentsUserUserIdGet({
          userId,
          getPaymentByUserIdRequest: { studentId: null },
          xTenantID: tenantId,
        });
        return payments ?? [];
      } catch (error) {
        if (
          error instanceof ResponseError &&
          (error.response.status === 404 || error.response.status === 403)
        ) {
          return [];
        }
        throw error;
      }
    },
    staleTime: PAYMENTS_STALE_TIME_MS,
  });

  return queryClient;
}
